import React from "react"
import { Link } from "gatsby"
import '../components/Blog.css'

import SEO from "../components/seo"
import Bingo from "../components/Bingo"
import '../components/theme'


const ThirdPage = () => (
  <main>
    <SEO title="Page Third" />
    <div className="CloseButton">
        <Link to="/"><img src={require('../images/button_close.svg')} /></Link>
    </div>
    <div className="Header">
        
    </div>
    <div class="BingoCollection">
    <Link to="/Blog">
        <Bingo 
                image = "https://p13.f2.n0.cdn.getcloudapp.com/items/wbukNrOY/space.png?v=a1fe80cc9d256295b7d49574469e95c1"
                title="🌘 Darkmode Proposal"
                subtitle="Darkmode Process・ Design System"
                text02="众所周知，随着 iOS 13 和 Android Q 的相继发布，对于 Darkmode 的支持变成了应用层的一个特性。通过对 Apple 和 Android 规范的梳理和已适配深色模式的产品分析进行系统性总结，探索输出能够满足小红书深色模式的整体定义和色彩规范文件，有序的开展 Darkmode 的适配工作。"
                link="Read Now" /></Link>
        <Bingo 
                image = "https://p13.f2.n0.cdn.getcloudapp.com/items/2NurKxw8/colorful.png?v=9335279b6b6e0d85268ec397a1f0e899"
                title="🎨 Color Design Proposal"
                subtitle="Color Basics・ Design System"
                text02="通过建立 Design System 的方式保证设计体系完善性和研发成本的可控性，设计侧从色彩层出发进行了探索，在符合当前品牌传达的基础上，定义 Primary、Secondary、Neutral 等颜色来保证整体 App 的良好体验。同时对于使用细节和二种模式兼容性的角度进行思考，..."
                link="Comming Soon"/>
        <Bingo 
                image = "https://p13.f2.n0.cdn.getcloudapp.com/items/KoueGy8P/workspace.png?v=d62775a556a9b6c96931a3d24c6b1e85"
                title="🏂 Team Cooperation"
                subtitle="Team Cooperation・ Workflow"
                text02="对于角色定位的问题曾经一直有所困扰，但当真的一个项目从产出到落地的具体环节中，对于资源的合理配置和流程的思考，让我越发明白设计师的职业划分是多么的狭隘，只有不断的从自身的实际情况出发，并作出相应的对策调整方案，才能够将项目更好更快的进行实际的落地..."
                link="Comming Soon"/>
      
            
        </div>
  </main>
)

export default ThirdPage
